export var FileCategory;
(function (FileCategory) {
    FileCategory["OTHER"] = "OTHER";
    FileCategory["MUSIC"] = "MUSIC";
    FileCategory["VIDEO"] = "VIDEO";
    FileCategory["IMAGE"] = "IMAGE";
    FileCategory["DOCS"] = "DOCS";
    FileCategory["FONT"] = "FONT";
})(FileCategory || (FileCategory = {}));
export var Availability;
(function (Availability) {
    Availability["UNKNOWN"] = "UNKNOWN";
    Availability["PUBLIC"] = "PUBLIC";
    Availability["PUBLIC_HIDDEN"] = "PUBLIC_HIDDEN";
    Availability["MEMBER"] = "MEMBER";
    Availability["PAID"] = "PAID";
    Availability["MEMBER_HIDDEN"] = "MEMBER_HIDDEN";
    Availability["PAID_HIDDEN"] = "PAID_HIDDEN";
})(Availability || (Availability = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var LibraryItemType;
(function (LibraryItemType) {
    LibraryItemType["FILE"] = "FILE";
    LibraryItemType["FOLDER"] = "FOLDER";
})(LibraryItemType || (LibraryItemType = {}));
export var LibraryItemSortBy;
(function (LibraryItemSortBy) {
    LibraryItemSortBy["CREATED_AT"] = "CREATED_AT";
    LibraryItemSortBy["NAME"] = "NAME";
    LibraryItemSortBy["TYPE"] = "TYPE";
    LibraryItemSortBy["TIMES_FAVORITED"] = "TIMES_FAVORITED";
    LibraryItemSortBy["UNIQUE_VIEWS"] = "UNIQUE_VIEWS";
    LibraryItemSortBy["LAST_MODIFIED"] = "LAST_MODIFIED";
    LibraryItemSortBy["SIZE"] = "SIZE";
})(LibraryItemSortBy || (LibraryItemSortBy = {}));
export var Orientation;
(function (Orientation) {
    Orientation["DESC"] = "DESC";
    Orientation["ASC"] = "ASC";
})(Orientation || (Orientation = {}));
export var AllowedAction;
(function (AllowedAction) {
    AllowedAction["MOVE"] = "MOVE";
    AllowedAction["RENAME"] = "RENAME";
    AllowedAction["DELETE"] = "DELETE";
    AllowedAction["DOWNLOAD"] = "DOWNLOAD";
    AllowedAction["CREATE_FOLDER"] = "CREATE_FOLDER";
    AllowedAction["UPLOAD_FILE"] = "UPLOAD_FILE";
    AllowedAction["VIEW"] = "VIEW";
    AllowedAction["FAVORITE"] = "FAVORITE";
    AllowedAction["MANAGE_PERMISSIONS"] = "MANAGE_PERMISSIONS";
})(AllowedAction || (AllowedAction = {}));
export var QuotaType;
(function (QuotaType) {
    QuotaType["STORAGE"] = "STORAGE";
    QuotaType["VIDEO_DURATION"] = "VIDEO_DURATION";
})(QuotaType || (QuotaType = {}));
export var Status;
(function (Status) {
    /** Action is allowed */
    Status["ALLOWED"] = "ALLOWED";
    /** Action is forbidden without any specific reason */
    Status["FORBIDDEN"] = "FORBIDDEN";
})(Status || (Status = {}));
export var Reason;
(function (Reason) {
    /** No exact reason. Depends on status if action is ALLOWED or FORBIDDEN */
    Reason["DEFAULT_REASON"] = "DEFAULT_REASON";
    /** This action is not allowed because it tried on root folder */
    Reason["NOT_ALLOWED_ON_ROOT"] = "NOT_ALLOWED_ON_ROOT";
    /** Site member is missing permission to perform action */
    Reason["MISSING_PERMISSION"] = "MISSING_PERMISSION";
    /** Site member who is performing this action is private so it is not allowed because it will expose site member */
    Reason["MUST_BE_PUBLIC"] = "MUST_BE_PUBLIC";
    /** Only available for item owners */
    Reason["OWNED_BY_ANOTHER_USER"] = "OWNED_BY_ANOTHER_USER";
    /** Can't delete non empty folder */
    Reason["FOLDER_NOT_EMPTY"] = "FOLDER_NOT_EMPTY";
    /**
     * Additionally is_allowed_for_all_members will be set if all members are granted this action
     * Usually this means user must log in in order to perform this action
     */
    Reason["MUST_BE_A_MEMBER"] = "MUST_BE_A_MEMBER";
    /** Action only available on root or first level subfolders */
    Reason["NOT_ALLOWED_ON_SUBFOLDERS_THIS_DEEP"] = "NOT_ALLOWED_ON_SUBFOLDERS_THIS_DEEP";
    /** Action only available on subfolders */
    Reason["NOT_ALLOWED_ON_FILES"] = "NOT_ALLOWED_ON_FILES";
    /** Library item is not found */
    Reason["NOT_FOUND"] = "NOT_FOUND";
})(Reason || (Reason = {}));
export var ReportReason;
(function (ReportReason) {
    ReportReason["UNWANTED_OR_SPAM"] = "UNWANTED_OR_SPAM";
    ReportReason["HARASSMENT_OR_BULLYING"] = "HARASSMENT_OR_BULLYING";
    ReportReason["INAPPROPRIATE_CONTENT"] = "INAPPROPRIATE_CONTENT";
    ReportReason["HATE_SPEECH_OR_GRAPHIC_VIOLENCE"] = "HATE_SPEECH_OR_GRAPHIC_VIOLENCE";
})(ReportReason || (ReportReason = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map